import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import React from 'react'
import { ArrowRightCircle } from 'react-feather'
import SectionInfoVehicle from './SectionInfoVehicle'
import SectionSale from './SectionSale'

export const FormStepApplication = ({useFetchInit}) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions
  } = useFetchInit



  // ------------------------------------------------ Acciones

  const {onSubmitFormApplies} = Actions
  // ------------------------------------------------ globalStates
  const { stepApplilication, formOpeningMode } = globalStates

  // ------------------------------------------------ Formularios
  const { FormRequestGlobal } = Forms
  const { formState, onInputChange, onSelectSearchChange } = FormRequestGlobal

  // ------------------------------------------------ FetchData
  const { fetchAllCustomers, fetchAllVehicles, fetchAllQuotes } = FetchData
  const { vehicles } = fetchAllVehicles
  const { customers } = fetchAllCustomers

  return (
    <form onSubmit={onSubmitFormApplies}>
        <Typography sx={{mt:3, fontWeight: 'bold'}} variant='subtitle2'>
          Datos Generales
        </Typography>
        <div className="border-bottom border-dark"></div>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <FormControl fullWidth>
              <label htmlFor="fecha_venta">* Fecha de venta</label>
                <TextField
                    id='fecha_venta'
                    name='fecha_venta'
                    value={ formState.fecha_venta }
                    onChange={ onInputChange }
                    size='small'
                    placeholder='Día de pago'
                    type='date'
                    variant={(formOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                    InputProps={{
                        readOnly: (formOpeningMode === 'READONLY') ? true : false 
                    }}
                    required
                />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <FormControl fullWidth>
              <label htmlFor="idcliente">* Cliente</label>
              <CustomAutocomplete 
                  customId="idcliente"
                  customName="idcliente"
                  customValue={formState.idcliente}
                  customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcliente', value: value.value }  })}
                  customPlaceholder='Seleccionar cliente'
                  customOptions={
                      customers.map(({ idcliente, dpi, nombre, apellido, departamento }) => ({
                          value: idcliente,
                          name: `${dpi} - ${nombre} ${apellido} - ${departamento}`
                      }))
                  }
                  customDisableClearable={true}
                  customDisabled={(formOpeningMode === 'READONLY') ? true : false}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl fullWidth>
              <label htmlFor="idvehiculo">* Vehiculo</label>
              <CustomAutocomplete 
                  customId="idvehiculo"
                  customName="idvehiculo"
                  customValue={formState.idvehiculo}
                  customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idvehiculo', value: value.value }  })}
                  customPlaceholder='Seleccione un vehiculo'
                  customOptions={
                      vehicles.map(({ idvehicle, marca, modelo, linea, matricula  }) => ({
                          value: idvehicle,
                          name: `${marca} - ${linea}, Año: ${modelo}, Matricula: ${matricula}`
                      }))
                  }
                  customDisableClearable={true}
                  customDisabled={(formOpeningMode === 'READONLY') ? true : false}
              />
            </FormControl>
          </Grid>
        </Grid>

        {(formState.idvehiculo>0) && (
          <>
            <SectionInfoVehicle 
              FormRequestGlobal = {FormRequestGlobal}
            />
            <SectionSale
              FormRequestGlobal = {FormRequestGlobal}
              formOpeningMode = {formOpeningMode}
            />
          </>
        )}

        <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
          <Grid item xs={12}>
            <div className="text-center">
                <Button
                    endIcon={<ArrowRightCircle/>}
                    variant="contained"
                    type="submit"
                    className='btn-round'
                    color='primary'
                    sx={{ mr: 2, ml: 2, mt: 3 }}
                >
                  Continuar
                </Button>
            </div>
          </Grid>
        </Grid>

    </form>

  )
}

